import { AfterContentInit, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Observable, Subject } from 'rxjs'
import { environment } from '../../../../../environments/environment'
import { BookingStatus, DeclineBookingBookingGQL, DeclineBookingGQL, DeclineBookingRequest } from '../../../../../graphql'
import { dialogWidth } from '../../../../constant'
import { Amplitude } from '../../../../injectable'
import { UnsubscribeOnDestroy } from '../../../../utility'
import { DeclineBookingReasonComponent } from './decline-booking-reason/decline-booking-reason'

@Component({
    selector: 'app-decline-booking',
    templateUrl: 'decline-booking.html'
})
export class DeclineBookingComponent extends UnsubscribeOnDestroy implements AfterContentInit {
    @Output() bookingDeclined = new EventEmitter<void>()
    @Input() bookingId: string
    @Input() tripId: string
    @Input() fullWidth = false
    BookingStatus = BookingStatus
    status: BookingStatus
    loading = false

    private bookingDeclinedSubject = new Subject<void>()

    // Constructor
    constructor(private _amplitude: Amplitude,
                private _declineBookingGQL: DeclineBookingGQL,
                private _declineBookingBookingGQL: DeclineBookingBookingGQL,
                private _dialog: MatDialog,
                private _snackBar: MatSnackBar) {
        super()
    }

    // Public
    declineBooking() {
        this._subscriptions.push(this._dialog.open(DeclineBookingReasonComponent, {
            width: dialogWidth.xs
        }).afterClosed().subscribe((reason: string) => {
            if (!reason) { return }

            this.loading = true

            const command: DeclineBookingRequest = {
                bookingId: this.bookingId,
                reason: reason,
                returnUrl: `${environment.memberUrl}search-listings`
            }
            this._subscriptions.push(this._declineBookingGQL
                .mutate({ input: command })
                .subscribe(async response => {
                    this.loading = false

                    if (response.errors && response.errors.length) {
                        this._snackBar.open('There was an error declining the booking, please try again later')
                        return
                    }
                    this._amplitude.logEventAndIncrement('travel.declined-booking.count','travel.decline-booking', {
                        bookingId: this.bookingId
                    })

                    this.bookingDeclined.next()
                    this.bookingDeclinedSubject.next()
                }))
        }))
    }

    bookingDeclinedChanges(): Observable<void> {
        return this.bookingDeclinedSubject.asObservable()
    }

    ngAfterContentInit() {
        this._subscriptions.push(this._declineBookingBookingGQL
            .watch({ bookingId: this.bookingId }, { fetchPolicy: 'no-cache' })
            .valueChanges
            .subscribe(result => {
                if (!result.loading) {
                    this.status = result.data.booking.status
                }
            }))
    }
}
